"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthRouter = void 0;
const core_1 = require("@ts-rest/core");
const zod_1 = require("zod");
const shared_1 = require("../../../shared");
const admin_auth_schema_1 = require("./admin.auth.schema");
const c = (0, core_1.initContract)();
exports.AuthRouter = c.router({
    setCustomClaim: {
        method: 'POST',
        path: '/custom-claims',
        body: zod_1.z.object({
            uid: zod_1.z.string(),
            wasticId: zod_1.z.string(),
            role: zod_1.z.enum(['USER', 'ADMIN', 'STAFF']),
        }),
        responses: { 200: (0, shared_1.createSuccessResponseSchema)(zod_1.z.undefined()) },
    },
    register: {
        method: 'POST',
        path: '/register',
        body: admin_auth_schema_1.AdminContractRegisterRequestSchema,
        responses: { 201: (0, shared_1.createSuccessResponseSchema)(admin_auth_schema_1.AdminContractRegisterResponseSchema) },
    },
    login: {
        method: 'POST',
        path: '/login',
        body: shared_1.EmptyBodySchema,
        headers: shared_1.ContractAuthHeaderSchema,
        responses: {
            200: (0, shared_1.createSuccessResponseSchema)(admin_auth_schema_1.AdminContractLoginResponseSchema),
            403: (0, shared_1.createErrorResponseSchema)(zod_1.z.string()),
        },
    },
    getSession: {
        method: 'GET',
        path: '/session',
        responses: { 200: (0, shared_1.createSuccessResponseSchema)(admin_auth_schema_1.AdminContractGetAuthSessionResponseSchema) },
    },
    logout: {
        method: 'DELETE',
        path: '/logout',
        body: shared_1.EmptyBodySchema,
        responses: { 200: (0, shared_1.createSuccessResponseSchema)(zod_1.z.undefined()) },
    },
    forgotPassword: {
        method: 'POST',
        path: '/forgot-password',
        body: admin_auth_schema_1.AdminContractForgotPasswordRequestSchema,
        responses: { 200: (0, shared_1.createSuccessResponseSchema)(zod_1.z.undefined()) },
    },
}, { pathPrefix: '/auth' });
